module.exports = __webpack_public_path__ + "static/img/logo_square.2a154cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_square.jpg
// module id = 8j6Y
// module chunks = 6